module.exports = __webpack_public_path__ + "media/images/front/about/thumbnail1-988c125ab2ff1fcf5b60b4decded93e0.jpg";